import { dataFormatters } from "../../../../../utils/dataFormatters";

export const DailyInspectionMethods = {
  getReportData: (reports) => {
    const assetMap = new Map();

    reports.forEach((curr) => {
      if (!curr) return;

      const unitId = curr.assetName;
      const hasDefect = curr.formData && curr.formData.some((f) => f && f.value === "Reported");

      assetMap.set(unitId, { unitId, defect: hasDefect });
    });

    return Array.from(assetMap.values());
  },

  extractDataForReportInfo: (reports) => {
    let startDateTime = [];
    let endDateTime = [];
    let userList = [];
    let location = "";
    let userPairs = [];

    const emailSet = new Set();

    reports.forEach((report) => {
      if (!report) return;

      let date = report.date ? dataFormatters.dateFormatter(report.date) : "";
      let time = report.date ? dataFormatters.timeFormatter12HourWithoutA(report.date) : "";
      let ampm = report.date ? dataFormatters.ampmFormatter(report.date) : "";

      if (report.otherInfo && report.otherInfo.inspectionEndTime) {
        let edate = dataFormatters.dateFormatter(report.otherInfo.inspectionEndTime);
        let etime = dataFormatters.timeFormatter12HourWithoutA(report.otherInfo.inspectionEndTime);
        let eampm = dataFormatters.ampmFormatter(report.otherInfo.inspectionEndTime);
        endDateTime.push({ date: edate, time: etime, ampm: eampm, datetime: report.otherInfo.inspectionEndTime });
      }

      startDateTime.push({ date: date, time: time, ampm: ampm, datetime: report.date });

      if (report.user && report.user.email && !emailSet.has(report.user.email)) {
        emailSet.add(report.user.email);
        userList.push(report.user);
      }

      if (report.lineName) location = report.lineName;
    });

    startDateTime.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

    if (endDateTime.length > 0) {
      endDateTime.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
    }

    for (let i = 0; i < userList.length; i += 2) {
      userPairs.push({
        first: userList[i],
        second: userList[i + 1] || null,
      });
    }

    return {
      startDateTime: startDateTime.length > 0 ? startDateTime[0] : null,
      endDateTime: endDateTime.length > 0 ? endDateTime[0] : null,
      userList: userPairs,
      location: location,
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/PATH/DailyInspectionReport/DailyMethods.js